import { vatDescription } from '../helpers/vatDescription';
import CountryService from '../services/CountryService';

const { country } = CountryService.GetInstance();

export default [
  {
    fieldName: 'Company',
    label: 'Company name',
    type: 'text',
  },
  {
    fieldName: 'CompanyRegistrationNumber',
    label: 'Company reg. number',
    type: 'text'
  },
  {
    fieldName: 'CompanyVatNumber',
    label: `Company ${vatDescription()} number`,
    type: 'text',
  },
  {
    fieldName: 'RequestAddress',
    type: 'address',
    label: 'Country',

    options: country ? [
      {
        label: country.name,
        value: country.code
      }
    ] : []
  },
  {
    fieldName: 'Message',
    isRequired: false,
    label: 'Message',
    type: 'textarea',
  },
];



// WEBPACK FOOTER //
// ./src/formFields/requestCompanyChange.tsx